var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.1,25a72,72,0,0,1,101.8,0L487,37.09a72,72,0,0,1,0,101.81L289.8,336.2a73.17,73.17,0,0,1-31.2,18.3l-100,28.6a22.76,22.76,0,0,1-23.6-7c-6.1-5.3-8.5-14.3-6.1-22.7l28.6-100a73.17,73.17,0,0,1,18.3-31.2Zm67,33.94c-8.5-9.37-23.7-9.37-33.1,0L377.9,88,424,134.1l29.1-30c9.4-8.5,9.4-23.7,0-33.07ZM203.7,266.6l-16.8,58.5,58.5-16.8a23.37,23.37,0,0,0,10.4-6.1L390.1,168,344,121.9,209.8,256.2A23.37,23.37,0,0,0,203.7,266.6ZM200,64a24,24,0,0,1,0,48H88a40,40,0,0,0-40,40V424a40,40,0,0,0,40,40H360a40,40,0,0,0,40-40V312a24,24,0,0,1,48,0V424a88,88,0,0,1-88,88H88A88,88,0,0,1,0,424V152A88,88,0,0,1,88,64Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.c83d8532.svg";
export { ForwardRef as ReactComponent };